import type { RouteObject } from 'react-router';

import * as searchInternshipsHorizonRouteExports from '#/modules/search/internships/page/SearchInternships.horizon-route';
import { searchInternshipsRoutePaths } from '#/modules/search/internships/routing/searchInternships.route-paths';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

export const searchInternshipsRouteObjects = searchInternshipsRoutePaths.map(
  (path) => ({
    path,
    ...horizonRouteToObject(searchInternshipsHorizonRouteExports),
  }),
) satisfies RouteObject[];
